@if (show()) {
  <ul class="breadcrumbs">
    @for (breadcrumb of breadcrumbs(); track breadcrumb) {
      <li>
        @if ($index !== 0) {
          <i class="fa-solid fa-chevron-right chevron"></i>
        }
        <yt-y-button
          [class.selected]="$index === breadcrumbs().length - 1"
          [disabled]="$index === breadcrumbs().length - 1"
          [label]="breadcrumb.label | translate"
          [text]="true"
          (onClick)="goTo(breadcrumb)"
        ></yt-y-button>
      </li>
    }
  </ul>
}
